export type IAttachments = {
    image: Array<string>,
    video: Array<string>,
    urls: Array<string>
}

// TODO: Change to useQnA.ts
export type IAnswers = {
    id: string,
    isBestAnswer: boolean,
    userName: string,
    userId: string,
    body: string,
    date: string,
    attachments: IAttachments,
    status: string,
    positiveVotes: string,
    negativeVotes: string,
    verifiedPurchase: boolean,
    userPic: string,
    flagBrand?: string,
    wasEdited?: boolean,
    timestamp?: number,
}
// TODO: Change to useQnA.ts
export type IQuestion = {
    id: string,
    body: string,
    username: string,
    date: string,
    answerCount: number,
    status: string,
    answers: Array<IAnswers>,
    totalAnswers: number,
    timestamp: number,
    userId: string,
    articleId: string,
    sendNotification: string,
    userPic: string,
    moreAnswers?: boolean,
};
export const questions: IQuestion[] = [
    {
        id: 'QuestionID123456',
        body: 'Is a Question from MirageJS or this is a real question that comes from Cyberpuerta the server ?',
        username: 'John Doe',
        date: '2021/24/06',
        answerCount: 3,
        status: 'check',
        answers: [
            {
                id: 'AnswerID123456',
                isBestAnswer: true,
                flagBrand: '0',
                userName: 'Jessam Smith',
                userId: 'Test user ID',
                body: 'This is the answer to the test question.',
                wasEdited: false,
                date: '2021/25/06',
                attachments: {
                    image: ['https://www.cyberpuerta.mx/out/cmsp/evergreen/optimized-leads/header.jpg', 'https://www.cyberpuerta.mx/out/cmsp/evergreen/optimized-leads/header.jpg', 'https://www.cyberpuerta.mx/out/cmsp/evergreen/optimized-leads/header.jpg'],
                    video: ['gLmR7q2tPcU'],
                    urls: ['https://www.cyberpuerta.mx/', 'https://www.cyberpuerta.mx/', 'https://www.cyberpuerta.mx/'],
                },
                status: 'active',
                positiveVotes: '10',
                negativeVotes: '2',
                verifiedPurchase: true,
                timestamp: 1620138774,
                userPic: 'https://base.cyberpuerta.mx/storage/avatars/43f8abdd3d398acedcf481b99b0de8d5.png?ts=1660258556',
            },
            {
                id: 'AnswerID123457',
                isBestAnswer: false,
                flagBrand: '0',
                userName: 'Some other person',
                userId: 'Test user ID',
                body: 'The second question of the first answer. I\'m testing how it is rendered in storybook.',
                wasEdited: false,
                date: '2021/25/07',
                attachments: {
                    image: [],
                    video: [],
                    urls: [],
                },
                status: 'active',
                positiveVotes: '0',
                negativeVotes: '0',
                verifiedPurchase: true,
                timestamp: 1620138774,
                userPic: 'https://base.cyberpuerta.mx/storage/avatars/43f8abdd3d398acedcf481b99b0de8d5.png?ts=1660258556',
            },
            {
                id: 'AnswerID123458',
                isBestAnswer: false,
                flagBrand: '0',
                userName: 'Brandon Bale',
                userId: 'Test user ID',
                body: 'It does look good!',
                wasEdited: false,
                date: '2021/26/07',
                attachments: {
                    image: [
                        // 'https://www.cyberpuerta.mx/out/pictures/cpqa_image/62d894c7e5443rn_image_picker_lib_temp_a121e7dd-372d-43d5-a5c2-1ae110eaa3e1.png'
                    ],
                    video: [],
                    urls: [
                        // 'https://www.gamefactor.mx/detalle/24/mg700',
                        // 'https://www.gamefactor.mx/descargables/manual-MG700.pdf'
                    ],
                },
                status: 'active',
                positiveVotes: '14',
                negativeVotes: '2',
                verifiedPurchase: true,
                timestamp: 1620138774,
                userPic: 'https://base.cyberpuerta.mx/storage/avatars/43f8abdd3d398acedcf481b99b0de8d5.png?ts=1660258556',
            },
        ],
        totalAnswers: 3,
        moreAnswers: false,
        timestamp: 1620138642,
        userId: 'Test user ID',
        articleId: 'b25f0c2803019e405a06b4736867f08c',
        sendNotification: '1',
        userPic: 'https://base.cyberpuerta.mx/storage/avatars/43f8abdd3d398acedcf481b99b0de8d5.png?ts=1660258556',
    },
    {
        id: 'QuestionID123457',
        body: 'Is this the second Question from MirageJS?',
        username: 'Emily Parker',
        date: '2021/26/05',
        answerCount: 1,
        status: 'check',
        answers: [
            {
                id: 'AnswerID123455',
                isBestAnswer: false,
                flagBrand: '0',
                userName: 'Nick Johnson',
                userId: 'Nick Johnson ID',
                body: 'Well, I\'m making up some test answers to check if everything goes well!',
                wasEdited: false,
                date: '2021/26/06',
                attachments: {
                    image: [],
                    video: [],
                    urls: [],
                },
                status: 'active',
                positiveVotes: '30',
                negativeVotes: '1',
                verifiedPurchase: true,
                timestamp: 1620138774,
                userPic: 'https://base.cyberpuerta.mx/storage/avatars/43f8abdd3d398acedcf481b99b0de8d5.png?ts=1660258556',
            },
        ],
        totalAnswers: 1,
        moreAnswers: false,
        timestamp: 1620138642,
        userId: 'Another user ID',
        articleId: '9303ef650db72a7d34132edd9267e204',
        sendNotification: '1',
        userPic: 'https://base.cyberpuerta.mx/storage/avatars/43f8abdd3d398acedcf481b99b0de8d5.png?ts=1660258556',
    },
    {
        id: 'QuestionID123458',
        body: 'Testing only question',
        username: 'Emily Parker',
        date: '2021/26/05',
        answerCount: 0,
        status: 'denied',
        answers: [],
        totalAnswers: 0,
        moreAnswers: false,
        timestamp: 1620138642,
        userId: 'Cool user ID',
        articleId: '1fa90c2280cba217158a011e5d649eef',
        sendNotification: '1',
        userPic: 'https://base.cyberpuerta.mx/storage/avatars/43f8abdd3d398acedcf481b99b0de8d5.png?ts=1660258556',
    },
];
